import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './tab_list.scss';

class TabList extends PureComponent {
  render() {
    const { activeIndex, children, onSelectTab } = this.props;
    const TabListChildren = React.Children.map(
      children,
      (child, index) =>
        child &&
        React.cloneElement(child, {
          ...child.props,
          isActive: index === activeIndex,
          onSelect: () => onSelectTab(index),
        }),
    );
    return <div className="tab-list">{TabListChildren}</div>;
  }
}

TabList.propTypes = {
  activeIndex: PropTypes.number,
  children: PropTypes.node.isRequired,
  onSelectTab: PropTypes.func,
};

TabList.defaultProps = {
  activeIndex: 0,
  onSelectTab: () => {},
};

export default TabList;
